const initialState = {
  opportunities: {},
  context: [],
  managementContext: {},
  summary: {},
  opportunityFilters: {
    limit: 10,
    offset: 0,
    isFavorited: false,
    search: undefined,
    ordering: undefined,
    status: 'active',
    opportunityType: [],
  },
  opportunityDetails: {},
  specificOpportunity: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case 'OPPORTUNITY.POPULATE_LIST':
      return {
        ...state,
        opportunities: action.data,
      };

    case 'OPPORTUNITY.SET_LIST_LOADING_STATUS':
      return {
        ...state,
        isOpportunitiesDataLoading: action.data,
      };

    case 'OPPORTUNITY.SET_CONTEXT_LOADING_STATUS':
      return {
        ...state,
        isOpportunitiesContextLoading: action.data,
      };

    case 'OPPORTUNITY.POPULATE_INFINITE_LIST':
      return {
        ...state,
        opportunities: {
          ...action.data,
          results: [...state.opportunities.results, ...action.data.results],
        },
      };
    case 'OPPORTUNITY.POPULATE_CONTEXT':
      return {
        ...state,
        context: action.data,
      };
    case 'OPPORTUNITY.POPULATE_SUMMARY':
      return {
        ...state,
        summary: action.data,
      };
    case 'OPPORTUNITY.SET_FILTER': {
      return {
        ...state,
        opportunityFilters: {
          ...state.opportunityFilters,
          ...action.filter,
        },
      };
    }
    case 'OPPORTUNITY.SET_DETAILS': {
      return {
        ...state,
        opportunityDetails: {
          ...state.opportunityDetails,
          ...action.opportunityDetails,
        },
      };
    }
    case 'OPPORTUNITY_MANAGEMENT.POPULATE_CONTEXT':
      return {
        ...state,
        managementContext: action.data,
      };
    case 'OPPORTUNITY.POPULATE_SPECIFIC_OPPORTUNITY':
      return {
        ...state,
        specificOpportunity: action.data,
      };
    case 'OPPORTUNITY.CLEAR_DETAILS':
      return {
        ...state,
        opportunityDetails: {},
      };
    case 'OPPORTUNITY.RESET_FILTERS': {
      return {
        ...state,
        opportunityFilters: {
          limit: 10,
          offset: 0,
          isFavorited: false,
          search: undefined,
          ordering: undefined,
          status: 'active',
          opportunityType: [],
        },
      };
    }
    default:
      return state;
  }
};
